import { AdminApi } from '../adminApi';
import { GraphApi } from '../graphApi';
import { initAppInsigths } from './appInsights';

async function setupAppInsights() : Promise<void> {
  const adminApi = new AdminApi();
  const graphApi = new GraphApi();
  const graphResponse = await graphApi.getDepartment();
  const appInsightsKeyResponse = await adminApi.getAppInsightsKey();
  await initAppInsigths(appInsightsKeyResponse.appInsigthsInstrumentationKey, graphResponse.department);
}

export default setupAppInsights;
